import styled from 'styled-components';

const Container = styled.div`
  padding: 0;
`;

export { Container };
